import { render, staticRenderFns } from "./ListServicesForTravel.vue?vue&type=template&id=e2753fc4"
import script from "./ListServicesForTravel.vue?vue&type=script&lang=js"
export * from "./ListServicesForTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports